import { Role } from "./enums/Role";
import { AccountInfo, PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../authConfig"; // Your MSAL configuration file

/**
 returns true if user is root or Admin user
 {IsRootOrAdminRole(account) ? "admin" : "user"}
 */
export const IsRootOrAdminRole = (accountInfo: AccountInfo) => {
  const role = GetRole(accountInfo);
  if (role == Role.root || role == Role.assessor) {
    return true;
  } else {
    return false;
  }
};

/**
 returns true if user is root user  
 */
export const IsRootRole = (accountInfo: AccountInfo) => {
  const role = GetRole(accountInfo);
  if (role == Role.root) {
    return true;
  } else {
    return false;
  }
};

/**
 returns true if user is Manager
 */
export const IsManagerRole = (accountInfo: AccountInfo) => {
  const role = GetRole(accountInfo);
  if (role == Role.manager) {
    return true;
  } else {
    return false;
  }
};

function GetRole(accountInfo: AccountInfo) {
  return accountInfo != undefined && accountInfo?.idTokenClaims != undefined && accountInfo?.idTokenClaims["extension_Roles"];
}

//using instead of msal/react for edge case when account info is needed outside of a jsx component
export function GetUserName() {
  try {
    const msal = new PublicClientApplication(msalConfig);
    const accounts = msal.getAllAccounts();
    return accounts[0].name;
  } catch (error) {
    return "";
  }
}

export function formatDate(date: string) {
  const d = new Date(date);
  return `${d.toLocaleDateString("en-CA")} ${d.toLocaleString("en-CA", { timeStyle: "medium", hour12: false })}`;
}
